import { useCallback } from 'react';

import { AvailableOrderOption } from '~components/OrderBySelector/OrderBySelector';
import useDispatchNumberLabel from '~hooks/useDispatchNumberLabel';

export default function useDispatchNumberSortOptions() {
  const { singular } = useDispatchNumberLabel();

  return useCallback(
    <T extends string>(options: AvailableOrderOption<T>[], dispatchNumberValue: T) =>
      options.map((option) =>
        option.value === dispatchNumberValue
          ? {
              ...option,
              label: singular('dispatch.dispatch_v2.orders_sort.dispatch_number'),
            }
          : option,
      ),
    [singular],
  );
}
